<template>
  <div class="device-main-content">
    <!-- 设备统计相关列表 -->
    <div class="device-detail-tabs">
      <div class="device-detail-tabs-nav" v-if="tabsLists.length > 0">
        <ul>
          <li
            v-for="item in tabsLists"
            :key="item.key"
            :class="activeKey === item.key ? 'active' : ''"
            @click="handleTabs(item.key)"
          >
            {{ item.name }}
          </li>
        </ul>
        <div class="device-detail-tabs-filter">
          <!-- 过滤条件：告警和故障统计 -->
          <div v-show="activeKey === '1' && AUTH_DEVICE_CHART_ALARM_FAULT">
            <!-- <div class="device-detail-tabs-traffic">
              <a-select
                v-model="alarmType"
                @change="handleAlarmType"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
              >
                <a-select-option
                  v-for="(item, index) in alarmTypeList"
                  :key="index"
                  :value="item.value"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div> -->
            <DateFilter
              @change="
                dateData => {
                  this.deviceStatusDate = dateData.date;
                  this.deviceStatusInterval = dateData.time;
                  this.deviceStatusDateModel = dateData.modeValue;
                  this.deviceStatusXTimeFormatter = dateData.timeFormat;

                  // 改变日期时获取数据
                  this.getStatusData();
                }
              "
              ref="StatusDateFilter"
            />
            <a-button type="primary" @click="getStatusData">{{ $t('com_btn_lookfor') }} </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  this.$refs.StatusDateFilter.reset();
                }
              "
              >{{ $t('com_btn_reset') }}</a-button
            >
          </div>

          <!-- 过滤条件：流量统计 -->
          <div v-show="activeKey === '2' && AUTH_DEVICE_CHART_TRAFFIC_HISTORY">
            <div class="device-detail-tabs-traffic">
              <a-select
                v-model="trafficType"
                @change="trafficTypeChange"
                :getPopupContainer="triggerNode => triggerNode.parentNode"
              >
                <a-select-option value="">
                  {{ $t('com_form_all') }}
                </a-select-option>
                <a-select-option
                  v-for="(item, index) in trafficTypeList"
                  :key="index"
                  :value="item.source"
                >
                  {{ item.source }}
                </a-select-option>
              </a-select>
            </div>

            <DateFilter
              @change="
                dateData => {
                  this.trafficDate = dateData.date;
                  this.trafficInterval = dateData.time;
                  this.trafficDateModel = dateData.modeValue;
                  this.trafficXTimeFormatter = dateData.timeFormat;
                  // 重新流量统计
                  this.getDeviceTrafficDevice();
                }
              "
              :mode="[
                {
                  value: 'month',
                  options: [60 * 24],
                },
                {
                  value: 'year',
                },
              ]"
              ref="TrafficDateFilter"
            />
            <a-button
              type="primary"
              @click="
                () => {
                  this.getDeviceTrafficDevice();
                }
              "
              >{{ $t('com_btn_lookfor') }}</a-button
            >
            <a-button
              type="default"
              @click="
                () => {
                  this.trafficType = '';
                  this.$refs.TrafficDateFilter.reset();
                }
              "
              >{{ $t('com_btn_reset') }}</a-button
            >
          </div>

          <!-- 过滤条件：故障排行 -->
          <div v-show="activeKey === '3' && AUTH_DEVICE_CHART_ALARM_FAULT">
            <div class="device-detail-tabs-traffic">
              <a-range-picker @change="handleRankingDate" v-model="rankingDate" />
            </div>

            <a-button type="primary" @click="getRankingData">{{ $t('com_btn_lookfor') }} </a-button>
            <a-button
              type="default"
              @click="
                () => {
                  rankingDate = undefined;
                }
              "
              >{{ $t('com_btn_reset') }}</a-button
            >
          </div>
        </div>
      </div>
      <div class="device-detail-tabs-wrapper">
        <NoAuth v-if="!(AUTH_DEVICE_CHART_ALARM_FAULT || AUTH_DEVICE_CHART_TRAFFIC_HISTORY)" />

        <!-- 状态统计 -->
        <div
          class="device-detail-tabs-content"
          style="position: relative;"
          v-if="activeKey === '1' && AUTH_DEVICE_CHART_ALARM_FAULT"
        >
          <Loading :show="true" v-if="deviceStatusLoading" />
          <ColumnarChart
            :dataSource="deviceStatusChartData"
            legendField="faultName"
            xField="startDate"
            :xLabelFormatter="
              value => {
                return moment(value).format(deviceStatusXTimeFormatter);
              }
            "
          />
        </div>

        <!-- 流量统计 -->
        <div
          class="device-detail-tabs-content"
          v-if="activeKey === '2' && AUTH_DEVICE_CHART_TRAFFIC_HISTORY"
        >
          <Loading :show="true" v-if="trafficDataLoading" />
          <LineChart
            :dataSource="trafficData"
            xField="startDate"
            yField="value"
            :xLabelFormatter="
              value => {
                return moment(value).format(trafficXTimeFormatter);
              }
            "
            :formatValue="filters.formatTraffficSize"
          />
        </div>

        <!-- 故障排行 -->
        <div
          class="device-detail-tabs-content"
          v-if="activeKey === '3' && AUTH_DEVICE_CHART_FAULT_RANKING"
        >
          <a-table
            :columns="rankingColumns"
            :data-source="rankingDataList"
            bordered
            rowKey="index"
            :loading="rankingLoading"
            :pagination="false"
            style="width:100%"
          >
            <!-- 时间 -->
            <template slot="totalDurationTime" slot-scope="text">
              {{ text | formatSeconds }}
            </template>
          </a-table>
          <div class="pagination">
            <Pagination
              :current.sync="rankingPagination.current"
              :total="rankingPagination.total"
              :pageSize.sync="rankingPagination.pageSize"
              :callback="rankingPageChange"
              @change="rankingPageChange"
              :showSizeChanger="false"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Config from '@/config';
import areaMixin from '@/mixins/area';
import DateFilter from '@/components/DateFilter';
import LineChart from '_c/charts/Line';
import * as API from '@/api/device';
import { splitTimeRangeWithData, mergeDataInSameDate, sortFaultData } from '@/libs/utils';
import ColumnarChart from '_c/charts/Columnar';
import moment from 'moment';
import deviceAuth from '@/views/device/mixins/deviceAuth';

export default {
  components: {
    DateFilter,
    LineChart,
    ColumnarChart,
  },
  mixins: [areaMixin, deviceAuth],
  props: {
    // 站点Id
    deviceId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      filters: this.$options.filters,
      console: window.console,
      moment,
      Config,

      // tabs
      tabsLists: [],
      // 当前激活的tab
      activeKey: '',

      chartData: [],

      // ------------------- 站点状态
      // 站点状态统计数据
      deviceStatusChartData: null,
      // 站点状态统计时间
      deviceStatusDate: null,
      // 站点状态间隔时间
      deviceStatusInterval: null,
      // 站点状态时间模式
      deviceStatusDateModel: null,
      // 站点状态X轴格式化
      deviceStatusXTimeFormatter: '',
      deviceStatusLoading: false,

      alarmTypeList: [
        // 0-total，1-离线(offline),2-告警(Alarm)，3-故障(Unavailable)。不填时则默认值为0",
        { value: 0, label: this.$t('com_form_all') },
        { value: 1, label: this.$t('com_fault_type_offline') },
        { value: 2, label: this.$t('com_fault_type_alarm') },
        { value: 3, label: this.$t('com_fault_type_unavailable') },
      ],

      // 当前选择的告警类型
      alarmType: 0,

      // ------------------- 流量统计
      // 流量类型
      trafficType: '',
      // 流量类型列表
      trafficTypeList: null,
      // 数量数据
      trafficData: null,
      // 站点状态统计时间
      trafficDate: null,
      // 站点状态间隔时间
      trafficInterval: null,
      // 站点状态时间模式
      trafficDateModel: null,
      // 站点状态X轴格式化
      trafficXTimeFormatter: '',
      trafficDataLoading: false,

      // ------------------- 故障排行
      rankingDate: null,
      rankingDataList: null,
      rankingLoading: false,
      // 分页
      rankingPagination: {
        // 当前页码
        current: 1,
        // 每页显示
        pageSize: 6,
        // 记录总条数
        total: 0,
      },
      rankingColumns: [
        {
          title: this.$t('com_table_index'),
          align: 'center',
          width: 50,
          customRender: (text, record, index) => {
            return index + 1;
          },
        },
        // 名称
        {
          title: this.$t('device_table_fault_name'),
          align: 'center',
          dataIndex: 'faultName',
          width: 130,
        },

        // 故障时间
        {
          title: this.$t('com_table_falut_time'),
          align: 'center',
          dataIndex: 'totalDurationTime',
          width: 130,
          scopedSlots: { customRender: 'totalDurationTime' },
        },

        // 故障次数
        {
          title: this.$t('com_table_fault_count'),
          align: 'center',
          dataIndex: 'totalDurationFrequency',
          width: 130,
        },
      ],

      // 页面初始化
      loading: true,
    };
  },
  created() {
    // tabs - 0:告警故障统计
    if (this.AUTH_DEVICE_CHART_ALARM_FAULT) {
      this.tabsLists.push({
        name: this.$t('device_alarm_fault_chart_title'),
        key: '1',
      });
    }

    // tabs - 1:流量统计
    if (this.AUTH_DEVICE_CHART_TRAFFIC_HISTORY) {
      this.tabsLists.push({
        name: this.$t('device_traffic_history_chart_title'),
        key: '2',
      });

      // 预先加载下拉选项
      this.getSiteTrafficType();
    }

    // tabs - 2:故障排行
    if (this.AUTH_DEVICE_CHART_FAULT_RANKING) {
      this.tabsLists.push({
        name: this.$t('device_fault_ranking_chart_title'),
        key: '3',
      });
    }

    if (this.tabsLists.length > 0) {
      this.activeKey = this.tabsLists[0].key;
    }

    // 加载tab数据(只有3时才加载 ，其他两个DateFilter组件初始化后会自动加载)
    if (this.activeKey === '3') {
      this.handleTabs(this.activeKey);
    }
  },

  methods: {
    // 故障排行 - date
    handleRankingDate(value) {
      this.rankingDate = value.length ? value : null;
      this.getRankingData();
    },

    // 流量类型handler
    handleAlarmType(value) {
      this.alarmType = value;

      this.getStatusData();
    },

    // 流量类型handler
    trafficTypeChange(value) {
      this.trafficType = value;
      this.getDeviceTrafficDevice();
    },

    // 获取流量类型
    getSiteTrafficType() {
      API.DeviceTrafficPlatform({
        devId: this.deviceId,
      }).then(res => {
        if (res.code === 0) {
          this.trafficTypeList = res.data;
        }
      });
    },

    // 获取流量列表
    getDeviceTrafficDevice() {
      if (this.activeKey !== '2') {
        return;
      }
      // 时间区间
      let startDate = '';
      let endDate = '';
      if (!this.trafficDate) {
        return;
      }

      if (this.trafficDate.length === 2) {
        startDate = this.trafficDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.trafficDate.format('YYYY/MM/DD 00:00:00');
        endDate = this.trafficDate.format('YYYY/MM/DD 23:59:59');
      }

      // devId:"设备ID，必填",
      // platform:"流量上报是区分到各平台，为空或者不传则表示全部。设备端流量平台，设备会和其他平台等(包括我们的飞充网、或者是客户自己开发的平台等)通信"，
      // startTime:"开始时间，必填"，
      // endTime:"结束时间，必填"
      this.trafficDataLoading = true;
      API.DeviceTrafficeCount({
        platform: this.trafficType,
        devId: this.deviceId,
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
      })
        .then(res => {
          if (res.code === 0) {
            const _data = res.data || [];
            // 根据选择的日期区间，合并数据
            this.trafficData = mergeDataInSameDate(
              startDate,
              endDate,
              this.trafficInterval,
              _data,
              'trafficTime',
              'networkTraffic'
            );
          }
        })
        .finally(() => {
          this.trafficDataLoading = false;
        });
    },

    // 获取状态统计数据
    getStatusData() {
      if (this.activeKey !== '1') {
        return;
      }

      // 时间区间
      let startDate = '';
      let endDate = '';
      if (this.deviceStatusDate && this.deviceStatusDate.length === 2) {
        startDate = this.deviceStatusDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.deviceStatusDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.deviceStatusDate
          ? this.deviceStatusDate.format('YYYY/MM/DD 00:00:00')
          : undefined;
        endDate = this.deviceStatusDate
          ? this.deviceStatusDate.format('YYYY/MM/DD 23:59:59')
          : undefined;
      }

      // devId:"设备ID，必填",
      // type:"故障类型，展示total/offline/Alarm/Unavailable；0-total，1-离线(offline),2-告警(Alarm)，3-故障(Unavailable)。不填时则默认值为0",
      // startTime:"开始时间，必填",
      // endTime:"结束时间，必填"
      const params = {
        devId: this.deviceId,
        type: this.alarmType || 0,
      };
      if (startDate) {
        params.startTime = new Date(startDate).getTime();
      }
      if (endDate) {
        params.endTime = new Date(endDate).getTime();
      }

      this.deviceStatusLoading = true;
      API.DeviceAlarmFaultCount(params)
        .then(res => {
          if (res.code === 0) {
            // console.log('res', res);
            let _data = res?.data || [];
            // 处理数据，添加一个报错名称的字段
            // faultDynamicStatus:"故障类型，1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)",

            _data = splitTimeRangeWithData(
              startDate,
              endDate,
              // 选中的时间间隔
              this.deviceStatusInterval,
              res.data,
              'startDate',
              'faultDynamicStatus'
            );
            _data.forEach(record => {
              // 错误类型
              record.faultName = record.faultDynamicStatus;
            });
            // 根据故障类型排序
            _data = sortFaultData(_data, 'faultDynamicStatus');

            this.deviceStatusChartData = _data;
          }
        })
        .finally(() => {
          this.deviceStatusLoading = false;
        });
    },

    // 获取故障排行
    getRankingData() {
      const params = {
        devId: this.deviceId,
      };
      if (this.rankingDate && this.rankingDate.length === 2) {
        params.date =
          new Date(this.rankingDate[0].format('YYYY/MM/DD 00:00:00')).getTime() +
          '-' +
          new Date(this.rankingDate[1].format('YYYY/MM/DD 23:59:59')).getTime();
      } else {
        params.date = undefined;
      }

      this.rankingLoading = true;
      API.DeviceFaultRanking(params)
        .then(res => {
          if (res && res.code === 0) {
            const _data = res.data || [];

            // 处理数据，添加一个报错名称的字段
            // faultDynamicStatus:"故障类型，1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)",
            const faultNames = {
              1: this.$t('com_fault_type_offline'),
              2: this.$t('com_fault_type_alarm'),
              3: this.$t('com_fault_type_unavailable'),
            };

            _data.forEach((item, index) => {
              item.faultName = faultNames[item.faultDynamicStatus];
              item.index = index;
            });

            this.rankingDataList = _data;
          }
        })
        .finally(() => {
          this.rankingLoading = false;
        });
    },

    handleTabs(tab) {
      this.activeKey = tab;

      // 获取流量
      if (tab === '1') {
        this.getStatusData();
      } else if (tab === '2') {
        this.getDeviceTrafficDevice();
      } else if (tab === '3') {
        this.getRankingData();
      }
    },

    // 分页
    rankingPageChange(value) {
      this.rankingPagination.current = value;
      this.getFailureRank();
    },
  },
};
</script>
<style lang="less" scoped>
.device-main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  // device category
  .device-device-category {
    display: flex;
    margin: 0;
    padding: 0 0 16px 0;
    gap: 16px;
    li {
      width: 16.6666%;
      background: none;
      > div,
      > a {
        height: 104px;
        background: #fff; /* 作为渐变的降级方案 */
        background: -webkit-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Safari、iOS */
        background: -moz-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Firefox */
        background: -o-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 Opera */
        background: -ms-linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 旧版 IE */
        background: linear-gradient(180deg, #fff 0%, #f9f9fd 100%); /* 标准语法 */
        display: flex;
        align-items: center;
        justify-content: flex-start;
        overflow: hidden;
        border-radius: 12px;
        border: 1px solid #fff;
        svg.icon {
          height: 56px;
          width: 56px;
          margin-left: 24px;
          margin-right: 12px;
        }
        .device-device-category-num {
          display: flex;
          flex-direction: column;
          justify-content: center;
          flex: 1;
          background: url('~@/assets/img/arrow_right.png') right 12px center no-repeat;
          background-size: 18px auto;
          strong {
            color: #000;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
          }
          span {
            color: #45454a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
          }
        }
      }
    }
  }

  // site status and info
  .device-status-info {
    display: flex;
    padding: 0;
    gap: 16px;
    min-height: 240px;
    margin-bottom: 16px;

    .device-status-info-title {
      color: #18181a;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
    }

    .device-status-info-wrapper {
      min-height: 184px;
      display: flex;
      align-items: center;
    }

    .device-status-info-left {
      flex: 0 0 40%;
      border-radius: 12px;
      padding: 15px 24px 24px 24px;
      background: #fff url('~@/assets/img/bg.png') right center no-repeat;
      background-size: 100% 100%;

      .device-status-info-left-num {
        margin: 0;
        padding: 0;
        display: flex;
        height: 84px;
        flex: 1;
        li {
          flex: 1;
          background: url('~@/assets/img/line_bg.png') right center no-repeat;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;

          strong {
            text-align: center;
            font-size: 36px;
            font-weight: 700;
          }

          span {
            color: rgba(0, 0, 0, 0.45);
            font-size: 16px;
            font-weight: 400;
            margin-bottom: 5px;
          }

          em {
            font-style: normal;
          }

          p {
            padding: 0;
            white-space: nowrap;
            i {
              border-radius: 4px;
              border: 1px solid #ffccc7;
              background: #fff1f0;
              margin: 0 4px;
              font-style: normal;
              padding: 0 4px;

              &.ca {
                border: 1px solid #ffccc7;
                background: #fff1f0;
              }

              &.ma {
                border: 1px solid #fff1b8;
                background: #fffbe6;
              }

              &.oa {
                border: 1px solid #b5f5ec;
                background: #e6fffb;
              }
            }
          }

          &:last-child {
            background: none;
          }
        }
      }
    }
  }

  // 站点简介
  .device-status-info-right {
    flex: 1;
    background: #fff;
    border-radius: 12px;
    padding: 10px 24px 24px 24px;
    height: 100%;

    // 图片
    .device-status-info-img {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      max-width: 25%;
      width: 280px;

      .device-status-info-space {
        width: 100%;
        min-height: 150px;
      }

      img {
        max-width: 100%;
        border-radius: 12px;
        height: 100%;
        width: 100%;
      }
    }

    // 简要描述
    .device-status-info-item {
      flex: 1;
      height: 100%;
      padding-left: 24px;
      margin: 0;

      li {
        padding-bottom: 12px;
        font-size: 14px;

        &:last-child {
          padding-bottom: 0;
        }

        a {
          cursor: pointer;
        }
      }
    }
  }

  // site detail tabs
  .device-detail-tabs {
    display: flex;
    border-radius: 12px;
    background: #fff;
    padding: 24px;
    min-height: 555px;
    flex-direction: column;
    flex: 1;

    // tabs nav
    .device-detail-tabs-nav {
      display: flex;
      overflow: hidden;
      justify-content: space-between;
      font-size: 14px;
      flex-wrap: wrap;

      ul {
        display: flex;
        align-items: center;
        gap: 24px;
        li {
          display: flex;
          height: 40px;
          padding: 16px 0px;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          color: rgba(0, 0, 0, 0.88);
          font-size: 16px;
          font-weight: 400;

          &.active {
            color: #1838d9;
            font-size: 16px;
            font-weight: 600;
            position: relative;
            cursor: pointer;

            &::after {
              content: ' ';
              display: block;
              width: 100%;
              height: 2px;
              background: #1838d9;
              position: absolute;
              bottom: 0;
            }
          }
        }
      }

      .device-detail-tabs-filter {
        display: flex;
        > div {
          display: flex;
          flex: 1;

          .device-detail-tabs-traffic {
            margin-right: 10px;
          }
        }

        button {
          margin-left: 12px;
        }
      }
    }

    // tabs content
    ::v-deep .device-detail-tabs-wrapper {
      display: flex;
      flex: 1;
      justify-content: center;
      width: 100%;
      position: relative;

      .page-loading {
        position: absolute;
        left: 48%;
        top: 40%;
        margin: 0 auto;
        z-index: 0;
      }

      .device-detail-tabs-content {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        z-index: 1;
        background: #fff;
        flex: 1;

        .device-detail-tabs-table {
          width: 100%;
          min-height: 100%;
        }

        .empty {
          margin-top: 200px;
          svg {
            width: 48px;
            height: 48px;
          }
        }
      }
    }
  }
}
</style>
